<template>
   <div class="activate_b">
     <!-- 22222222222 -->
      <div class="title_t">激活最新时间: <span style="color: #aaa;margin-left: 5px;"> {{  timei}}</span></div>
      <div class="Btn">
        <el-button type="primary" size="medium " @click="chongqiBtn">重新激活</el-button>
        <el-button type="primary" class="huifu" size="medium " @click="huifuClick">恢复出厂配置</el-button>
        <!-- <el-button size="medium ">恢复出厂设置</el-button> -->
      </div>
   </div>
</template>
<script>
import {chongxinDevice ,deviceGetFind,resetFactory} from '@/assets/api/zhongduan.js'

export default {
   name: '',
   components: {
     
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       timei:''
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     
   },
   created(){
    this.getFInd()
   },
   methods: {
    huifuClick () {
        this.$confirm('请确认是否重新恢复出厂设置', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
                }).then(() => {
            chongxinDevice(this.$route.query.deviceId).then((res) => {
                this.resetFactory()
                console.log(res,'重启');
            })
        }).catch((err) => {
            console.log(err,'禁用启用');

        });
       
    },
    resetFactory () {
        let params = {
            imei: this.$route.query.iemi,
        }
        resetFactory(params).then((res)=> {
            // console.log(res)
            this.$message({
                    type: 'success',
                    message: '恢复出厂设置成功!'
                });
        }).catch((err)=> {
            console.log(err,)
            })
    },
    getFInd(){
        const params = {
            deviceId:this.$route.query.deviceId
        }
        deviceGetFind(params).then((res ) => {
            // console.log(res.data.started,'查看激活时间');
            this.timei = res.data.firstActivateDate
            
        })
    },
    chongqiBtn(){
        this.$confirm('请确认是否重新激活', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                     }).then(() => {
                    chongxinDevice(this.$route.query.deviceId).then((res) => {
                        this.getFInd()
                        console.log(res,'重启');
                        
                    })

                    }).catch((err) => {
                        console.log(err,'禁用启用');

                    });
    },

   }
};
</script>
<style lang='scss' scoped>
    .title_t{
        margin-top: 15px;
        height: 30px;
        width: 800px;
        background-color: #EDF6FF;
        // text-align: center;
        line-height: 30px;
        // margin-left: 20px;
        padding-left: 10px;
    }
    .Btn{
        margin-top: 15px;
        .huifu {
            background-color: #fff;
            color: #409eff;
        }
    }
</style>